var _circle, _line, _path, _line2, _line3, _line4, _line5, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 37,
    viewBox: "0 0 99 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.6828,
    cy: 24.8781,
    r: 4.51485,
    fill: "#47FFBD"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.75247,
    y1: 4.8264,
    x2: 15.2291,
    y2: 23.1605,
    stroke: "white",
    strokeWidth: 6.96648,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5977 4.82812L15.6756 24.4314",
    stroke: "white",
    strokeWidth: 6.96648,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 63.9683,
    y1: 4.8264,
    x2: 74.4449,
    y2: 23.1605,
    stroke: "white",
    strokeWidth: 6.96648,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 63.9683,
    y1: 4.8264,
    x2: 74.4449,
    y2: 23.1605,
    stroke: "white",
    strokeWidth: 6.96648,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 85.1554,
    y1: 4.72111,
    x2: 70.8547,
    y2: 33.3225,
    stroke: "white",
    strokeWidth: 6.96648,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 85.1554,
    y1: 4.72111,
    x2: 70.8547,
    y2: 33.3225,
    stroke: "white",
    strokeWidth: 6.96648,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.2827,
    cy: 13.98,
    r: 10.4497,
    stroke: "white",
    strokeWidth: 6.96648
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7325 13.9814C55.7325 19.7527 51.054 24.4312 45.2827 24.4312C39.5115 24.4312 34.833 19.7527 34.833 13.9814",
    stroke: "white",
    strokeWidth: 6.96648,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.18fa7f456855e53501cc857337e0ffe2.svg";
export { ForwardRef as ReactComponent };